export default "__VITE_ASSET__AOo1jAtm__"